var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroidDownloadIconSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 128,
    height: 37,
    rx: 4.5,
    fill: "#333",
    stroke: "#A6A6A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.959 9.303c0 .796-.235 1.43-.707 1.903-.535.562-1.232.843-2.09.843-.82 0-1.519-.285-2.093-.855-.575-.57-.862-1.278-.862-2.122 0-.844.287-1.551.862-2.122a2.86 2.86 0 012.093-.856c.408 0 .798.08 1.168.24.37.159.668.37.89.636l-.5.501c-.377-.45-.895-.676-1.557-.676a2.16 2.16 0 00-1.554.633c-.437.422-.656.97-.656 1.644 0 .674.219 1.222.656 1.644a2.16 2.16 0 001.553.633c.636 0 1.165-.212 1.59-.637.275-.276.434-.66.476-1.154h-2.066v-.685h2.757c.027.149.04.292.04.43z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.96 9.304h-.095c0 .778-.227 1.382-.678 1.835l-.002.001c-.518.544-1.184.814-2.021.815-.8-.001-1.468-.274-2.027-.828-.557-.555-.833-1.232-.834-2.054.001-.823.277-1.5.834-2.054.559-.554 1.227-.828 2.027-.829.395 0 .771.077 1.13.231.36.155.643.359.854.611l.073-.061-.067-.067-.5.501.067.067.073-.06c-.394-.474-.947-.712-1.63-.71-.622-.002-1.168.22-1.62.659-.456.439-.685 1.017-.684 1.712-.001.694.228 1.272.684 1.712.452.438.998.66 1.62.66.656 0 1.215-.223 1.655-.665.295-.295.461-.705.505-1.213l.009-.104h-2.075V8.97h2.662v-.095l-.093.017c.026.144.038.28.038.413h.19c0-.144-.014-.293-.041-.447L42 8.779h-2.931v.874h2.16v-.095l-.094-.008c-.042.478-.194.838-.45 1.096-.407.406-.907.607-1.521.608-.577 0-1.066-.2-1.488-.606-.418-.405-.626-.921-.627-1.575.001-.654.21-1.171.627-1.576a2.064 2.064 0 011.488-.606c.64.002 1.125.214 1.484.642l.067.08.573-.575.062-.062-.056-.066a2.437 2.437 0 00-.925-.663A3.024 3.024 0 0039.164 6c-.843 0-1.57.296-2.16.884-.593.586-.892 1.323-.89 2.189-.002.865.297 1.602.89 2.19.59.586 1.317.883 2.16.882.877 0 1.605-.291 2.158-.873l-.068-.066.067.068c.49-.492.734-1.156.734-1.97h-.095zM46.329 6.923h-2.59V8.73h2.336v.685h-2.337v1.807h2.59v.7h-3.32v-5.7h3.32v.7z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.33 6.923v-.095h-2.686v1.998h2.337v.494h-2.337v1.998h2.591v.51h-3.131v-5.51h3.131v.605h.095v-.095.095h.095V6.128h-3.51v5.89h3.51v-.89h-2.59V9.51h2.335v-.875h-2.336V7.018h2.59v-.095h-.094zM49.414 11.922h-.731v-5h-1.59v-.7h3.91v.7h-1.589v5z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.411 11.923v-.095h-.636v-5h-1.59v-.51h3.72v.51h-1.589v5.095h.095v-.095.095h.095V7.018h1.589v-.89h-4.099v.89h1.589v5H49.506v-.095h-.095zM53.828 11.922v-5.7h.73v5.7h-.73z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.83 11.923h.094V6.318h.541v5.51h-.636v.095h.095-.095v.095h.826v-5.89H53.734v5.89h.095v-.095zM57.805 11.922h-.732v-5h-1.589v-.7h3.91v.7h-1.59v5z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.802 11.923v-.095h-.637v-5h-1.589v-.51h3.72v.51h-1.589v5.095h.095v-.095.095h.095V7.018h1.589v-.89h-4.1v.89h1.59v5H57.896v-.095h-.095zM63.163 10.708c.421.427.936.64 1.546.64.609 0 1.124-.213 1.545-.64.421-.427.632-.973.632-1.636 0-.663-.21-1.209-.632-1.636a2.085 2.085 0 00-1.546-.64c-.609 0-1.124.213-1.545.64-.42.427-.632.973-.632 1.636 0 .663.212 1.21.632 1.636zm3.631.477c-.559.577-1.254.864-2.085.864-.832 0-1.528-.287-2.086-.864-.56-.575-.838-1.28-.838-2.113s.279-1.538.838-2.113c.558-.577 1.254-.865 2.086-.865.826 0 1.52.29 2.082.868.56.579.842 1.282.842 2.11 0 .833-.28 1.538-.839 2.113z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.16 10.709l-.067.067c.436.444.981.67 1.613.668a2.181 2.181 0 001.612-.668c.44-.445.66-1.02.66-1.703s-.22-1.259-.66-1.703a2.181 2.181 0 00-1.612-.669 2.182 2.182 0 00-1.613.669c-.439.444-.66 1.02-.66 1.703s.221 1.258.66 1.703l.067-.067.068-.067c-.403-.41-.604-.926-.605-1.57.001-.643.202-1.159.605-1.569.405-.41.89-.61 1.478-.612a1.99 1.99 0 011.477.612c.403.41.604.926.605 1.57 0 .643-.202 1.159-.605 1.57a1.99 1.99 0 01-1.477.611 1.992 1.992 0 01-1.479-.612l-.067.067zm3.632.477l-.068-.066c-.544.558-1.209.834-2.018.835-.81-.001-1.475-.277-2.018-.835l-.002-.003.002.003c-.542-.56-.81-1.235-.81-2.047s.268-1.488.81-2.048c.543-.558 1.208-.834 2.018-.835.804.001 1.467.278 2.014.84.544.562.814 1.236.815 2.043-.001.812-.27 1.487-.811 2.047l.068.066.068.066c.575-.591.865-1.325.865-2.18 0-.849-.292-1.58-.869-2.175-.578-.596-1.301-.898-2.15-.897-.854-.001-1.58.3-2.154.893-.576.592-.865 1.325-.864 2.18-.001.854.288 1.588.864 2.18l.003.002-.003-.003c.574.594 1.3.894 2.154.893.853 0 1.578-.299 2.154-.893l-.068-.066zM68.656 11.922v-5.7h.89l2.765 4.435h.031l-.031-1.099V6.222h.731v5.7h-.763l-2.892-4.649h-.032l.032 1.1v3.55h-.73z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.657 11.923h.095V6.318h.742l2.765 4.434h.182l-.034-1.195V6.318h.541v5.51h-.615L69.44 7.18h-.181l.034 1.195v3.454h-.636v.095h.095-.095v.095h.826V8.371l-.032-1.1-.095.003v.095h.032v-.095l-.08.05 2.92 4.694H73.138v-5.89H72.217V9.56l.031 1.1.095-.003v-.095h-.031v.095l.08-.05L69.6 6.128h-1.037v5.89h.094v-.095zM98.391 28.073h1.77V16.197h-1.77v11.876zm15.936-7.598l-2.028 5.15h-.061l-2.105-5.15h-1.905l3.156 7.197-1.8 4.003h1.846l4.864-11.2h-1.967zm-10.033 6.25c-.581 0-1.388-.29-1.388-1.01 0-.916 1.007-1.267 1.875-1.267.779 0 1.144.168 1.617.397a2.147 2.147 0 01-2.104 1.88zm.213-6.51c-1.281 0-2.607.566-3.156 1.819l1.57.657c.335-.657.96-.871 1.616-.871.915 0 1.846.55 1.861 1.528v.122c-.321-.183-1.006-.458-1.845-.458-1.693 0-3.417.931-3.417 2.673 0 1.59 1.388 2.613 2.943 2.613 1.19 0 1.846-.534 2.258-1.16h.061v.916h1.707V23.5c0-2.108-1.57-3.285-3.598-3.285zm-10.934 1.706h-2.516v-4.07h2.516c1.323 0 2.074 1.096 2.074 2.035 0 .92-.751 2.035-2.074 2.035zm-.045-5.724h-4.24v11.876h1.769v-4.5h2.47c1.961 0 3.889-1.422 3.889-3.688 0-2.265-1.928-3.688-3.888-3.688zM70.41 26.727c-1.222 0-2.246-1.026-2.246-2.434 0-1.423 1.023-2.464 2.246-2.464 1.206 0 2.153 1.041 2.153 2.464 0 1.408-.947 2.434-2.153 2.434zm2.031-5.587h-.06c-.398-.474-1.162-.903-2.124-.903-2.016 0-3.865 1.776-3.865 4.056 0 2.265 1.849 4.025 3.865 4.025.962 0 1.726-.428 2.123-.918h.061v.582c0 1.546-.825 2.372-2.153 2.372-1.085 0-1.757-.78-2.032-1.439l-1.543.643c.443 1.072 1.62 2.388 3.575 2.388 2.077 0 3.834-1.225 3.834-4.21v-7.254h-1.68v.658zm2.902 6.933h1.772V16.197h-1.772v11.876zm4.385-3.918c-.046-1.56 1.206-2.356 2.107-2.356.703 0 1.299.351 1.497.857l-3.605 1.5zm5.498-1.346c-.335-.904-1.36-2.572-3.452-2.572-2.077 0-3.803 1.638-3.803 4.04 0 2.266 1.71 4.041 4.002 4.041 1.848 0 2.918-1.132 3.36-1.79l-1.374-.919c-.458.674-1.085 1.118-1.986 1.118s-1.543-.414-1.956-1.225l5.392-2.234-.183-.46zm-42.959-1.332v1.714h4.094c-.122.964-.443 1.668-.932 2.158-.595.597-1.527 1.255-3.161 1.255-2.52 0-4.491-2.035-4.491-4.56 0-2.526 1.97-4.562 4.49-4.562 1.36 0 2.353.536 3.086 1.225l1.207-1.209c-1.024-.98-2.383-1.73-4.292-1.73-3.453 0-6.355 2.816-6.355 6.276 0 3.458 2.902 6.274 6.355 6.274 1.863 0 3.268-.612 4.368-1.76 1.13-1.132 1.482-2.724 1.482-4.01 0-.398-.03-.765-.092-1.07h-5.758zm10.505 5.25c-1.222 0-2.276-1.01-2.276-2.45 0-1.453 1.054-2.448 2.276-2.448 1.222 0 2.276.995 2.276 2.449 0 1.439-1.054 2.449-2.276 2.449zm0-6.49c-2.23 0-4.048 1.7-4.048 4.04 0 2.327 1.818 4.041 4.048 4.041s4.048-1.714 4.048-4.04c0-2.342-1.818-4.04-4.048-4.04zm8.83 6.49c-1.221 0-2.276-1.01-2.276-2.45 0-1.453 1.055-2.448 2.276-2.448 1.222 0 2.276.995 2.276 2.449 0 1.439-1.054 2.449-2.276 2.449zm0-6.49c-2.23 0-4.047 1.7-4.047 4.04 0 2.327 1.817 4.041 4.047 4.041 2.23 0 4.048-1.714 4.048-4.04 0-2.342-1.818-4.04-4.048-4.04z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.966 30.343l-.07-.068c-.276-.292-.439-.746-.439-1.335v.139-21.01-.005V8.208c0-.637.19-1.117.508-1.405l11.747 11.77-11.746 11.77zm-.509-22.28zm.004-.156v-.002.002zm0-.007z",
    fill: "url(#AndroidDownloadIconSvg_svg__paint0_linear_2212_866)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.626 22.638l.09-.051 4.639-2.641c.442-.252.737-.558.884-.88-.147.322-.442.628-.884.88l-4.64 2.641-.089.05zm.001-.14l-3.916-3.924 3.916-3.924 4.728 2.691c.6.342.937.782.993 1.232v.002c-.056.45-.393.89-.993 1.232l-4.728 2.692z",
    fill: "url(#AndroidDownloadIconSvg_svg__paint1_linear_2212_866)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.804 30.792a1.22 1.22 0 000 0zm0-.14c-.328.001-.614-.106-.837-.308l11.746-11.77 3.916 3.925-13.762 7.835c-.381.216-.742.319-1.062.319zm-.84-.171a1.296 1.296 0 01-.062-.06l.061.06z",
    fill: "url(#AndroidDownloadIconSvg_svg__paint2_linear_2212_866)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.712 18.573L6.965 6.803a1.22 1.22 0 01.837-.308c.321 0 .682.103 1.064.32l13.762 7.834-3.916 3.924zm4.005-4.012L8.866 6.676c-.382-.217-.743-.32-1.064-.32h-.004.005c.321 0 .682.102 1.063.32l13.85 7.885z",
    fill: "url(#AndroidDownloadIconSvg_svg__paint3_linear_2212_866)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89 30.788c.298-.017.628-.12.975-.317l13.761-7.834L8.865 30.47c-.347.198-.677.3-.975.317zm-.925-.306l-.003-.003.003.003zm-.064-.063l-.006-.006.006.006z",
    fill: "#000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.625 22.638l.09-.051-.09.05z",
    fill: "url(#AndroidDownloadIconSvg_svg__paint4_linear_2212_866)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.803 30.792a1.22 1.22 0 01-.838-.31v.001l-.003-.002-.061-.06-.006-.006.07-.07c.223.2.51.308.838.308.32 0 .681-.103 1.062-.319L22.628 22.5l.088.088-.09.051-13.761 7.835c-.347.197-.677.3-.975.317l-.087.002z",
    fill: "url(#AndroidDownloadIconSvg_svg__paint5_linear_2212_866)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.896 30.415c-.276-.293-.439-.747-.439-1.335 0 .588.163 1.042.439 1.335z",
    fill: "#000"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.896 30.415c-.276-.293-.439-.746-.439-1.335v-.138c0 .588.163 1.042.439 1.335l.07.067-.07.071z",
    fill: "url(#AndroidDownloadIconSvg_svg__paint6_linear_2212_866)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.895 30.415l.071-.07-.071.07z",
    fill: "url(#AndroidDownloadIconSvg_svg__paint7_linear_2212_866)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.238 19.065a1.166 1.166 0 010 0z",
    fill: "#000"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.348 18.573c0-.497-.332-.994-.994-1.371l-4.639-2.641 4.64 2.64c.662.378.994.875.993 1.372z",
    fill: "#404040"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.35 18.573c-.056-.45-.393-.89-.993-1.232l-4.728-2.691.088-.089 4.64 2.641c.662.377.993.874.993 1.371z",
    fill: "url(#AndroidDownloadIconSvg_svg__paint8_linear_2212_866)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M6.457 8.065zm.004-.154V7.91v.002zm0-.004v-.005.005zm0-.006c.055-.976.585-1.54 1.334-1.543a1.218 1.218 0 00-.83.309l-.002.002a1.267 1.267 0 00-.067.066c-.25.264-.406.66-.435 1.166z",
    fill: "#404040"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M6.457 8.208v-.139-.005-.001c0-.053.001-.104.004-.153v-.003-.002-.004V7.9c.029-.507.186-.902.435-1.166l.07.07c-.32.287-.509.767-.509 1.404zm.506-1.54l.003-.003-.003.003z",
    fill: "url(#AndroidDownloadIconSvg_svg__paint9_linear_2212_866)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.627 14.65L8.865 6.813c-.382-.216-.743-.319-1.064-.319a1.22 1.22 0 00-.837.308l-.07-.07a1.27 1.27 0 01.068-.066l.003-.002c.221-.2.504-.307.829-.309H7.8c.321 0 .682.103 1.064.32l13.85 7.885-.088.088z",
    fill: "url(#AndroidDownloadIconSvg_svg__paint10_linear_2212_866)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "AndroidDownloadIconSvg_svg__paint0_linear_2212_866",
    x1: 17.671,
    y1: 7.847,
    x2: 1.728,
    y2: 23.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AndroidDownloadIconSvg_svg__paint1_linear_2212_866",
    x1: 29.08,
    y1: 18.575,
    x2: 6.138,
    y2: 18.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AndroidDownloadIconSvg_svg__paint2_linear_2212_866",
    x1: 20.542,
    y1: 20.755,
    x2: -1.079,
    y2: 42.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AndroidDownloadIconSvg_svg__paint3_linear_2212_866",
    x1: 3.92,
    y1: -0.26,
    x2: 13.574,
    y2: 9.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AndroidDownloadIconSvg_svg__paint4_linear_2212_866",
    x1: 29.179,
    y1: 18.574,
    x2: 5.88,
    y2: 18.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#CC9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#CC8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AndroidDownloadIconSvg_svg__paint5_linear_2212_866",
    x1: 20.54,
    y1: 20.755,
    x2: -1.081,
    y2: 42.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC2E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C0E4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AndroidDownloadIconSvg_svg__paint6_linear_2212_866",
    x1: 17.671,
    y1: 7.848,
    x2: 1.728,
    y2: 23.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00A7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00B8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AndroidDownloadIconSvg_svg__paint7_linear_2212_866",
    x1: 20.752,
    y1: 20.755,
    x2: -0.868,
    y2: 42.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0333C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB0F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AndroidDownloadIconSvg_svg__paint8_linear_2212_866",
    x1: 29.082,
    y1: 18.574,
    x2: 6.14,
    y2: 18.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFBC40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AndroidDownloadIconSvg_svg__paint9_linear_2212_866",
    x1: 17.671,
    y1: 7.847,
    x2: 1.727,
    y2: 23.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#40B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#40CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#40DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AndroidDownloadIconSvg_svg__paint10_linear_2212_866",
    x1: 3.919,
    y1: -0.26,
    x2: 13.573,
    y2: 9.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65B895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#62BD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#50DB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#44ED98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F498"
  })))));
}
export default SvgAndroidDownloadIconSvg;